module.exports = __webpack_public_path__ + "img/bank (1).b76bd0aa.svg";